function initializeSaveState(form) {
  if (form.dataset.saveStateInitialized === "true") return

  const root = form.closest(".school-settings")
  const indicators = root?.querySelectorAll("[data-save-status]") || []
  let dirty = form.dataset.initialState === "dirty"

  const setState = (state) => {
    const labels = {
      saved: ["已儲存", "目前顯示的是最新設定"],
      dirty: ["未儲存", "請儲存本頁變更"],
      saving: ["儲存中…", "正在送出設定"]
    }

    indicators.forEach((indicator) => {
      indicator.dataset.state = state
      indicator.querySelector("[data-save-status-label]").textContent = labels[state][0]
      indicator.querySelector("[data-save-status-detail]").textContent = labels[state][1]
    })
  }

  const markDirty = () => {
    dirty = true
    setState("dirty")
  }

  form.addEventListener("input", markDirty)
  form.addEventListener("change", markDirty)
  form.addEventListener("submit", () => {
    dirty = false
    setState("saving")
  })
  window.addEventListener("beforeunload", (event) => {
    if (!dirty) return
    event.preventDefault()
    event.returnValue = ""
  })

  setState(dirty ? "dirty" : "saved")
  form.dataset.saveStateInitialized = "true"
}

function initializeMarkdownEditor(editor) {
  if (editor.dataset.markdownInitialized === "true") return

  const source = editor.querySelector("[data-markdown-source]")
  const preview = editor.querySelector("[data-markdown-preview]")
  const panels = editor.querySelectorAll("[data-markdown-panel]")
  const buttons = editor.querySelectorAll("[data-markdown-mode]")
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
  let previewedSource = null

  const showPanel = (mode) => {
    panels.forEach((panel) => { panel.hidden = panel.dataset.markdownPanel !== mode })
    buttons.forEach((button) => {
      const selected = button.dataset.markdownMode === mode
      button.setAttribute("aria-selected", String(selected))
    })
  }

  const renderPreview = async () => {
    const content = source.value
    showPanel("preview")
    if (content === previewedSource) return

    preview.classList.add("is-loading")
    preview.textContent = "正在產生預覽…"

    try {
      const response = await fetch(editor.dataset.previewUrl, {
        method: "POST",
        headers: {
          "Accept": "text/html",
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({ content })
      })
      if (!response.ok) throw new Error(`Preview failed: ${response.status}`)

      preview.innerHTML = await response.text()
      previewedSource = content
    } catch (_error) {
      preview.textContent = "預覽暫時無法產生，請稍後再試。"
    } finally {
      preview.classList.remove("is-loading")
    }
  }

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      if (button.dataset.markdownMode === "preview") renderPreview()
      else showPanel("edit")
    })
  })

  editor.dataset.markdownInitialized = "true"
}

function initializeSchoolSettings() {
  document.querySelectorAll("[data-school-settings-form]").forEach(initializeSaveState)
  document.querySelectorAll("[data-markdown-editor]").forEach(initializeMarkdownEditor)
}

document.addEventListener("DOMContentLoaded", initializeSchoolSettings)
document.addEventListener("turbo:load", initializeSchoolSettings)
